const COLUMNS = [
  {
    title: 'Support',
    links: ['Manage your trips', 'Safety resource centre', 'FAQs'],
  },
  {
    title: 'Discover',
    links: ['Safari and coast stays', 'Seasonal and holiday deals', 'Travel articles'],
  },
  {
    title: 'Terms',
    links: ['Privacy & cookies', 'Terms & conditions', 'Accessibility'],
  },
  {
    title: 'Partners',
    links: ['Host login', 'Partner help'],
  },
  {
    title: 'About',
    links: ['About Kaya Serene Villa', 'How we work', 'Careers', 'Dar es Salaam office'],
  },
];

export default function Footer({ onToast }) {
  const click = (label) => onToast(`${label} is part of the Kaya Serene Villa experience.`);

  return (
    <footer>
      <div className="wrap footer-main">
        <div className="footer-top">
          <p className="footer-word">Kaya Serene Villa</p>
          <p>Apartments in Dar es Salaam.</p>
        </div>
        <div className="footer-grid">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4>{col.title}</h4>
              {col.links.map((l) => (
                <button key={l} onClick={() => click(l)}>{l}</button>
              ))}
            </div>
          ))}
        </div>
        <p className="copyright">© 2026 Kaya Serene Villa</p>
      </div>
    </footer>
  );
}
